module.exports = __webpack_public_path__ + "static/media/courses_wine.d7c8b1c9.svg";